import { InjectionToken } from '@angular/core';
import { UIBModalService } from '@b2b/types/core';

/**
 * Bridge to AngularJS `$uibModal` (ui.bootstrap).
 *
 * ModalService is a thin wrapper over `$uibModal`. Since `$uibModal` is an
 * AngularJS-only service (provided by the `ui.bootstrap` module) with no
 * Angular 18 equivalent in this hybrid app, the port stays for the lifetime
 * of the AngularJS shell — it is not a temporary scaffold like the
 * domain-service ports.
 */
export const UIB_MODAL_PORT = new InjectionToken<UIBModalService>('UIB_MODAL_PORT');
